export const selectUserView = state => {
  return state.view;
};

export const selectFlowLayout = state => {
  return state.view.flows.flowLayout;
};
export const selectFlowStatusFilter = state => {
  return state.view.flows.filters && state.view.flows.filters.status;
};
export const selectFlowSegmentFilter = state => {
  return state.view.flows.filters && state.view.flows.filters.segment;
};
export const selectFlowCreatedByFilter = state => {
  return state.view.flows.filters && state.view.flows.filters.createdBy;
};
export const selectFlowSearchFilter = state => {
  return state.view.flows.filters && state.view.flows.filters.search;
};
export const selectFlowTagsFilter = state => {
  const tags =
    (state.view.flows.filters && state.view.flows.filters.tags) || [];
  return typeof tags === 'string' ? [tags] : tags;
};
export const selectFlowSortOption = state => {
  return state.view.flows.sort;
};
